const betManager = {
  init(betData, { bets, lines }) {
    this.bets = bets;
    this.lines = lines;

    this.popup = document.querySelector('#bet');
    this.closeBtn = document.querySelector('#bet-close');
    this.betUpBtn = document.querySelector('#bet-value-up');
    this.betDownBtn = document.querySelector('#bet-value-down');
    this.betValue = document.querySelector('#bet-value');
    this.linesUpBtn = document.querySelector('#bet-lines-up');
    this.linesDownBtn = document.querySelector('#bet-lines-down');
    this.linesValue = document.querySelector('#bet-lines');

    this.setBet(betData);

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.closeBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('close'));
    this.betUpBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('bet-up'));
    this.betDownBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('bet-down'));
    this.linesUpBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('lines-up'));
    this.linesDownBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('lines-down'));
  },

  setBet({
    bet, lines, firstBet, lastBet, firstLine, lastLine,
  }) {
    this.betValue.innerText = `${bet} G`;
    this.linesValue.innerText = lines;

    const btns = {
      betDownBtn: firstBet,
      betUpBtn: lastBet,
      linesDownBtn: firstLine,
      linesUpBtn: lastLine,
    };

    Object.keys(btns).forEach((key) => {
      this[key].disabled = btns[key];
    });
  },

  setValidState(valid) {
    [this.betValue, this.linesValue].forEach(el =>
      el.classList[valid ? 'remove' : 'add']('bet__value--error'));
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  show() {
    this.popup.hidden = false;
  },

  hide() {
    this.popup.hidden = true;
  },

  isVisible() {
    return !this.popup.hidden;
  },
};

export default betManager;



// WEBPACK FOOTER //
// ../base/js/managers/bet.js